<app-dialog
    [config]="data.config"
    (actionButtonClicked)="onFormSubmit($event)"
>
    <ng-container dialog-title>Create Product</ng-container>
    <ng-container
        dialog-process-in-progress
        *ngIf="createProductForm && createProductForm.form"
    >
        <form
            [formGroup]="createProductForm.form"
            autocomplete="off"
        >
            <app-select
                #productTypeSelectInput
                [formControlName]="createProductForm.controls.type.name"
                [control]="createProductForm.controls.type"
            ></app-select>
            <app-panel-input
                [formControlName]="createProductForm.controls.name.name"
                [control]="createProductForm.controls.name"
            ></app-panel-input>
            <app-panel-input
                [formControlName]="createProductForm.controls.nameBG.name"
                [control]="createProductForm.controls.nameBG"
            ></app-panel-input>
            <app-panel-input
                [formControlName]="createProductForm.controls.code.name"
                [control]="createProductForm.controls.code"
            ></app-panel-input>
            <app-panel-input
                [formControlName]="createProductForm.controls.version.name"
                [control]="createProductForm.controls.version"
            ></app-panel-input>
            <app-select
                [formControlName]="createProductForm.controls.currency.name"
                [control]="createProductForm.controls.currency"
            ></app-select>
            <app-panel-input
                [formControlName]="createProductForm.controls.issuedBy.name"
                [control]="createProductForm.controls.issuedBy"
            ></app-panel-input>
            <app-datepicker
                [formControlName]="createProductForm.controls.issuedOn.name"
                [control]="createProductForm.controls.issuedOn"
            ></app-datepicker>
            <app-datepicker
                [formControlName]="createProductForm.controls.expiresOn.name"
                [control]="createProductForm.controls.expiresOn"
            ></app-datepicker>
            <app-panel-input
                [formControlName]="createProductForm.controls.durationInMonths.name"
                [control]="createProductForm.controls.durationInMonths"
            ></app-panel-input>
            <app-amount-input
                [formControlName]="createProductForm.controls.nominalValue.name"
                [control]="createProductForm.controls.nominalValue"
            ></app-amount-input>
        </form>
    </ng-container>
</app-dialog>